
<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
    <p style="color: black"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>
<div class="content-wrapper" style="min-height: 307px">

    <div class="col-12">
        <div class="row">
            <!-- รถบรรทุก -->
            <div class="card card-secondary">
                <div class="card-header">
                    <div class="card-title">
                        <i class="fas fa-chart-line"></i>  การตัดพื้นที่รื้อตอและระดับพื้นที่ต่างๆ
                    </div>                   
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" (click)="LoadgroupData();LoadsupcodeData();"><i class="fas fa-sync"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                        </button>                      
                    </div>
                </div>
                <div class="card-body">                   
                    <div class="row" >
                        <div class="col-4">
                            <ul class="nav nav-tabs mb-3"id="vert-tabs-tab" role="tablist" aria-orientation="horizontal" >   
                                <li class="nav-item " role="presentation">                        
                                <a class="nav-item nav-link active" id="tabs-tab3" (click)="setDataTeble(0);" data-toggle="pill">
                                    <p style="font-weight: bold;">อิงตามนักส่งเสริม</p></a>
                                </li>
                
                                <li class="nav-item" role="presentation" >                        
                                <a class="nav-item nav-link" id="tabs-tab2" (click)="setDataTeble(1);" data-toggle="pill" >
                                    <p style="font-weight: bold;">อิงตามกลุ่มตัด</p></a>                
                                </li>
                            </ul>
                        </div>
                        <div class="col-4">                                                    
                            <div class="input-group mb-3" [formGroup]="datagoup">       
                                <span class="input-group-text" id="basic-addon2">เลือกโซน</span>             
                                <select class="form-select" formControlName="szone" (click)="setDataTeble(10);">
                                    <option value="0" disabled>-- กรุณาเลือก --</option>
                                    <option value="All" selected>All | ข้อมูลทุกโซน</option>
                                    <option value="P1">P1 | ข้อมูลส่วนที่ 1</option>
                                    <option value="P2">P2 | ข้อมูลส่วนที่ 2</option>
                                    <option value="P3">P3 | ข้อมูลส่วนที่ 3</option>                      
                                    <option value="P4">P4 | ข้อมูลส่วนที่ 4</option>
                                    <option *ngFor="let item of zonecode" [ngValue]="item.SUPZONE">{{item.SUPZONE}} | {{item.ZONENAME}}</option>                        
                                </select>
                            </div>
                        </div>
                        <div class="col-4">
                        </div>
                    </div> 

                    <div class="row" >
                        <div class="col-md-12 ml-md" >
                            <table class="table table-bordered table-sm" style="width:100%"> 
                                <thead class="thead-light">  
                                    <tr style="text-align:center">
                                        <th style="width:25%">เป้าหมายพื้นที่รื้อตอ</th>
                                        <th style="width:25%">พื้นที่รื้อตอสะสม</th>
                                        <th style="width:25%">%การรื้อตอ</th>                                                                                   
                                        <th style="width:25%">คงเหลือพื้นที่รื้อตอ</th>                       
                                    </tr>
                                </thead>
                                <tr style="text-align:center" *ngFor="let item of lastsum" class="danger">
                                    <td style="background-color:#bdfaf7">{{item.areaDs|number}}</td>
                                    <td style="background-color:#b6ccfc">{{item.areaDsf|number}}</td>
                                    <td style="background-color:#ffdbbd">{{item.pc_areaDs|number}}</td>                                                                                       
                                    <td style="background-color:#f7b1fa">{{item.difareaDsf|number}}</td>                                                 
                                  </tr>
                              </table>
                        </div>
                        <hr>
                        <div class="col-md-12 ml-md" >
                            <table class="table table-bordered table-sm" style="width:100%">  
                                <thead class="thead-light">                                          
                                    <tr class="success" style="text-align:center">
                                        <th colspan="2" style="width:20%">พื้นที่ระดับ 1 (ุ่ลุ่มมาก)</th>
                                        <th colspan="2" style="width:20%">พื้นที่ระดับ 2 (ุ่ลุ่ม)</th>
                                        <th colspan="2" style="width:20%">พื้นที่ระดับ 3 (ุ่เหมาะสม)</th>                                                                                   
                                        <th colspan="2" style="width:20%">พื้นที่ระดับ 4 (ุ่สูง)</th> 
                                        <th colspan="2" style="width:20%">พื้นที่ระดับ 5 (ุ่สูงมาก)</th>                                        
                                    </tr>
                                    <tr style="text-align:center">
                                        <th style="background-color:#bcf3ba">พื้นที่</th>
                                        <th style="background-color:#d2c5ff">การตัด</th>
                                        <th style="background-color:#bcf3ba">พื้นที่</th>                                                                                   
                                        <th style="background-color:#d2c5ff">การตัด</th> 
                                        <th style="background-color:#bcf3ba">พื้นที่</th>
                                        <th style="background-color:#d2c5ff">การตัด</th>
                                        <th style="background-color:#bcf3ba">พื้นที่</th>
                                        <th style="background-color:#d2c5ff">การตัด</th>                                                                                   
                                        <th style="background-color:#bcf3ba">พื้นที่</th> 
                                        <th style="background-color:#d2c5ff">การตัด</th>                                                                            
                                    </tr>
                                </thead>

                                <tr style="text-align:center" *ngFor="let item of lastsum">
                                    <td>{{item.arealv1|number}}</td>
                                    <td>{{item.arealv1f|number}}</td>
                                    <td>{{item.arealv2|number}}</td>                                                                                       
                                    <td>{{item.arealv2f|number}}</td>
                                    <td>{{item.arealv3|number}}</td>
                                    <td>{{item.arealv3f|number}}</td>
                                    <td>{{item.arealv4|number}}</td>
                                    <td>{{item.arealv4f|number}}</td>                                                                                       
                                    <td>{{item.arealv5|number}}</td>
                                    <td>{{item.arealv5f|number}}</td>

                                  </tr>
                              </table>
                        </div>
                        <hr>
                    </div>                        

                    <div class="row" >
                        <!-- 'code','Codename','areaDs','difareaDsf','arealv1','arealv2','arealv3','arealv4','arealv5','action'-->
                        <mat-card  >
                            <mat-card-header>
                                <mat-card-title>ตารางข้อมูล{{txtTap}}</mat-card-title>                                
                              </mat-card-header>
                            <mat-form-field appearance="standard">
                                <!--<mat-label>ค้นหาชื่อ-สกุล รหัสรถ</mat-label>-->                        
                                <div class="input-group mb-3">                                
                                    <div class="col-md-6">
                                        <input matInput (keyup)="applyFilter($event)" placeholder="รายการที่ต้องการหา" #input>
                                    </div>
                                </div>
                            </mat-form-field>                            
                            <table mat-table [dataSource]="Dataalltruck" matSort style="width: 100%;"*ngIf="Dataalltruck != null">                            
                                <ng-container matColumnDef="Code" sticky><!-- เลขรถตัด Column -->
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader"> รหัส </th>
                                    <td mat-cell *matCellDef="let element"> {{element.Code}} </td>
                                </ng-container>
    
                                <ng-container matColumnDef="Codename" sticky><!-- ชื่อกลุ่มตัด Column -->
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader" > ชื่อ </th>
                                    <td mat-cell *matCellDef="let element" 
                                    [ngClass]="element.Codename.substr(0,3) == '*รว' ? 'bg-info': '' 
                                            || element.Codename.substr(0,3) == '**ร' ? 'bg-primary' :''
                                            || element.Codename.substr(0,3) == '***' ? 'bg-success' :''"
                                            >
                                     
                                    {{element.Codename}} </td>
                                </ng-container>   
    
                                <ng-container matColumnDef="areaDs">
                                    <th mat-header-cell *matHeaderCellDef  class="matHeader"> พื้นที่รื้อตอ</th>
                                    <td mat-cell *matCellDef="let element"> {{element.areaDs}} / {{element.areaDsf}} / {{element.pc_areaDs}} % </td>
                                </ng-container>    
    
                                <ng-container matColumnDef="difareaDsf">
                                    <th mat-header-cell *matHeaderCellDef  class="matHeader"> พื้นที่รื้อตอคงเหลือ</th>
                                    <td mat-cell *matCellDef="let element"> {{element.difareaDsf}}</td>
                                </ng-container> 
    
                                <ng-container matColumnDef="arealv1">
                                    <th mat-header-cell *matHeaderCellDef  class="arealv1"> พื้นที่ระดับ 1 (ุ่ลุ่มมาก) </th>
                                    <td mat-cell *matCellDef="let element"> {{element.arealv1 }} / {{element.arealv1f}} / {{element.pc_arealv1}} %  </td>
                                </ng-container>  
    
                                <ng-container matColumnDef="arealv2">
                                    <th mat-header-cell *matHeaderCellDef  class="matHeader"> พื้นที่ระดับ 2 (ุ่ลุ่ม)  </th>
                                    <td mat-cell *matCellDef="let element"> {{element.arealv2 }} / {{element.arealv2f}} / {{element.pc_arealv2}} % </td>
                                </ng-container> 
                                                            
                                <ng-container matColumnDef="arealv3" >
                                    <th mat-header-cell *matHeaderCellDef   class="matHeader"> พื้นที่ระดับ 3 (ุ่เหมาะสม)  </th>
                                    <td mat-cell *matCellDef="let element"> {{element.arealv3 }} / {{element.arealv3f}} / {{element.pc_arealv3}} % </td>
                                </ng-container>
    
                                <ng-container matColumnDef="arealv4">
                                    <th mat-header-cell *matHeaderCellDef  class="matHeader"> พื้นที่ระดับ 4 (ุ่สูง)  </th>
                                    <td mat-cell *matCellDef="let element"> {{element.arealv4 }} / {{element.arealv4f}} / {{element.pc_arealv4}} % </td>
                                </ng-container> 
    
                                <ng-container matColumnDef="arealv5">
                                    <th mat-header-cell *matHeaderCellDef  class="matHeader"> พื้นที่ระดับ 5 (ุ่สูงมาก)  </th>
                                    <td mat-cell *matCellDef="let element"> {{element.arealv5 }} / {{element.arealv5f}} / {{element.pc_arealv5}} % </td>
                                </ng-container>                                                                                   

                            <!--
                            <ng-container matColumnDef="check_cut"> 
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader"> สถานะปัจจุบัน </th>
                                <td mat-cell *matCellDef="let element">
                                    <p class="bg-success text-white" *ngIf="element.check_cut===1"> ตัด </p>
                                    <p class="bg-warning text-white" *ngIf="element.check_cut===2"> ไม่ตัด </p>
                                    <p class="bg-danger text-white" *ngIf="element.check_cut===3"> เสียซ่อม </p>
                                </td> 
                            </ng-container>
                            -->      

                            <!--
                             <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader"> ตัวเลือก </th>
                                <td mat-cell *matCellDef="let element" > 
                                    &nbsp;
                                    <button class="btn btn-danger btn-sm" *ngIf="settap == 4"  (click)="CancleTruck(element.TRUCK_NO)"> 
                                        <i class="fas fa-edit" ></i> 
                                    </button>
                                </td>
                            </ng-container>   
                            -->
                            
                            <tr class="headText text-primary" mat-header-row  *matHeaderRowDef="displayedColumns ; sticky: true;" style="background-color: rgb(100, 185, 250);"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            
                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="4">ไม่มีข้อมูลตรงกัน "{{input.value}}"</td>
                            </tr>
                            </table>
                            <mat-paginator  [pageSizeOptions]="[10,25,50,100,200,500]" showFirstLastButtons aria-label="Select page of periodic elements"></mat-paginator>
                        </mat-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
